import { TextCustomProps, TextAppearance, TextTag, TextSize, TextLineHeight, TextColor, TextWeight } from "@vw-marketing/us-components";

export const getResultsLabel = (label: string, result: number) => {
    let numberLabel = result.toString();
    if (result > 100) {
        let numberArray = [...numberLabel];
        numberLabel = `${numberArray[0]}${"0".repeat(numberArray.length - 1)}+`
    }
    return label.replace(
        '%%NUM%%',
        numberLabel || '',
      );
}

export const filterMobileTextStyle: TextCustomProps = {
    appearance: TextAppearance.headline200,
    tag: TextTag.h2,
    style: {
      fontSize: TextSize.TextSize32,
      lineHeight: TextLineHeight.TextLineHeight36,
      color: TextColor.inherit,
      fontWeight: TextWeight.bold
    },
  };
